import { Navigate, Route, Routes } from 'react-router-dom';
import { useAuth } from '@/hooks/useAuth';
import { Layout } from '@/components/Layout';
import { LoginPage } from '@/pages/LoginPage';
import { DashboardPage } from '@/pages/DashboardPage';
import { MetricsPage } from '@/pages/MetricsPage';
import { RankingPage } from '@/pages/RankingPage';
import { LinksPage } from '@/pages/LinksPage';
import { LeadsPage } from '@/pages/LeadsPage';
import { ReceiptsPage } from '@/pages/ReceiptsPage';
import { CRYPTO_TAB_PATH } from '@/lib/receipts';
import { LeveragePage } from '@/pages/LeveragePage';
import { MembersPage } from '@/pages/MembersPage';
import { MemberDetailPage } from '@/pages/MemberDetailPage';
import { GoalsPage } from '@/pages/GoalsPage';

function FullScreenLoader() {
  return (
    <div style={{ minHeight: '100vh', display: 'grid', placeItems: 'center' }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: 10 }} className="muted">
        <span className="spinner" />
        <span style={{ fontSize: 13 }}>Carregando…</span>
      </div>
    </div>
  );
}

export function App() {
  const { user, initializing, isAdmin } = useAuth();

  if (initializing) return <FullScreenLoader />;
  if (!user) return <LoginPage />;

  return (
    <Routes>
      <Route element={<Layout />}>
        <Route path="/" element={<DashboardPage />} />
        <Route path="/metricas" element={<MetricsPage />} />
        <Route path="/ranking" element={<RankingPage />} />
        <Route path="/links" element={<LinksPage />} />
        <Route path="/comprovantes" element={<ReceiptsPage />} />
        <Route path="/alavancagem" element={<LeveragePage />} />
        <Route path="/clientes" element={<LeadsPage />} />
        {/* Endereços antigos continuam funcionando. */}
        <Route path="/registros" element={<Navigate to="/clientes" replace />} />
        <Route path="/depositos" element={<Navigate to="/comprovantes" replace />} />
        <Route path="/conferencia" element={<Navigate to="/comprovantes" replace />} />
        {/* As vendas em cripto viraram uma aba dos comprovantes. */}
        <Route path="/cripto" element={<Navigate to={CRYPTO_TAB_PATH} replace />} />
        <Route path="/membros" element={isAdmin ? <MembersPage /> : <Navigate to="/" replace />} />
        <Route path="/membros/:id" element={isAdmin ? <MemberDetailPage /> : <Navigate to="/" replace />} />
        <Route path="/metas" element={<GoalsPage />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Route>
    </Routes>
  );
}
